export default (theme) => ({
  iconTabs: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  iconWrapper: {
    width: 20,
    height: 20,
    margin: 'auto',
    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
  tab: {
    position: 'relative',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'none',
    borderRadius: 10,
    border: 'none',
    width: 40,
    height: 40,
    '& svg': {
      transition: 'opacity .2s ease-in-out',
      fill: theme.palette.primary.main,
    },
    '&:hover svg': {
      opacity: 0.5,
    },
    [theme.breakpoints.down('md')]: {
      width: 42,
      height: 42,
    },
  },
  activeTab: {
    background: theme.palette.primary.main,
    '& svg': {
      fill: theme.palette.background.default,
    },
    '&:hover svg': {
      opacity: 1,
    },
  },
  count: {
    position: 'absolute',
    bottom: '70%',
    right: '65%',
    display: 'inline-flex',
    verticalAlign: 'middle',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 22,
    width: 'auto',
    padding: '5px 4px',
    height: 22,
    fontSize: 14,
    backgroundColor: '#FF0000',
    color: theme.palette.background.default,
    borderRadius: 50,
  },
});
